(function () {
  if (window.CartDrawerRedesignInitialized) return;
  window.CartDrawerRedesignInitialized = true;

  var productCache = {};
  var renderSequence = 0;

  function getShopRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || "/").replace(/\/?$/, "/");
  }

  function getDrawer() {
    return document.querySelector("[data-cart-drawer]");
  }

  function escapeHtml(value) {
    var element = document.createElement("div");
    element.textContent = value == null ? "" : String(value);
    return element.innerHTML;
  }

  function escapeAttribute(value) {
    return escapeHtml(value).replace(/`/g, "&#96;");
  }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(Number(cents) || 0, format);
    }
    return ((Number(cents) || 0) / 100).toFixed(2);
  }

  function fetchCart() {
    return fetch(getShopRoot() + "cart.js", {
      credentials: "same-origin",
      cache: "no-store"
    }).then(function (response) {
      if (!response.ok) throw new Error("Could not load cart");
      return response.json();
    });
  }

  function fetchProduct(item) {
    var cacheKey = String(item.product_id || item.handle || item.url || "");
    if (productCache[cacheKey]) return productCache[cacheKey];

    var productUrl;
    if (item.handle) {
      productUrl = getShopRoot() + "products/" + encodeURIComponent(item.handle) + ".js";
    } else {
      var parsedUrl = new URL(item.url, window.location.origin);
      productUrl = parsedUrl.pathname.replace(/\/$/, "") + ".js";
    }

    productCache[cacheKey] = fetch(productUrl, {
      credentials: "same-origin",
      cache: "force-cache"
    }).then(function (response) {
      return response.ok ? response.json() : null;
    }).catch(function () {
      return null;
    });

    return productCache[cacheKey];
  }

  function enrichCart(cart) {
    return Promise.all((cart.items || []).map(function (item) {
      return fetchProduct(item).then(function (product) {
        var variants = product && product.variants ? product.variants : [];
        var variant = variants.find(function (candidate) {
          return String(candidate.id) === String(item.variant_id);
        });
        return { item: item, product: product, variant: variant || null };
      });
    })).then(function (items) {
      return { cart: cart, items: items };
    });
  }

  function getItemPrices(entry) {
    var item = entry.item;
    var variant = entry.variant;
    var current = Number(item.final_price != null ? item.final_price : item.price) || 0;
    var original = Number(item.original_price != null ? item.original_price : item.price) || current;
    var compareAt = Number(variant && variant.compare_at_price) || 0;
    var displayCompare = compareAt > current ? compareAt : (original > current ? original : 0);
    var quantity = Number(item.quantity) || 0;

    return {
      current: current,
      original: original,
      compareAt: compareAt,
      displayCompare: displayCompare,
      lineSaving: displayCompare > current ? (displayCompare - current) * quantity : 0,
      productSaving: compareAt > original ? (compareAt - original) * quantity : 0
    };
  }

  function renderItem(entry, moneyFormat) {
    var item = entry.item;
    var prices = getItemPrices(entry);
    var title = item.product_title || item.title || "";
    var image = item.image || "";
    var variantTitle = item.variant_title && item.variant_title.indexOf("Default") === -1
      ? item.variant_title
      : "";
    var priceHtml = "";

    if (prices.displayCompare > prices.current) {
      priceHtml += '<span class="cart-drawer-item__compare money">' +
        formatMoney(prices.displayCompare, moneyFormat) + "</span>";
    }
    priceHtml += '<span class="cart-drawer-item__price money">' +
      formatMoney(prices.current, moneyFormat) + "</span>";

    return '<li class="item cart-drawer-item" data-cart-line-key="' + escapeAttribute(item.key) + '">' +
      '<a href="' + escapeAttribute(item.url || "#") + '" class="product-image cart-drawer-item__media">' +
        (image ? '<img src="' + escapeAttribute(image) + '" alt="' + escapeAttribute(title) + '" loading="lazy">' : "") +
      "</a>" +
      '<div class="product-details cart-drawer-item__details">' +
        '<p class="product-name cart-drawer-item__title"><a href="' + escapeAttribute(item.url || "#") + '">' + escapeHtml(title) + "</a></p>" +
        '<div class="cart-drawer-item__prices">' + priceHtml + "</div>" +
        (variantTitle ? '<span class="variants cart-drawer-item__variant">' + escapeHtml(variantTitle) + "</span>" : "") +
        (prices.lineSaving > 0 ? '<span class="cart-drawer-item__saving">Економія ' + formatMoney(prices.lineSaving, moneyFormat) + "</span>" : "") +
        '<button type="button" class="btn-remove cart-drawer-item__remove" data-cart-remove aria-label="Видалити ' + escapeAttribute(title) + '">Видалити</button>' +
      "</div>" +
      '<div class="cart-drawer-item__quantity" aria-label="Кількість">' +
        '<button type="button" data-cart-quantity-change="-1" aria-label="Зменшити кількість">−</button>' +
        '<span data-cart-quantity>' + (Number(item.quantity) || 0) + "</span>" +
        '<button type="button" data-cart-quantity-change="1" aria-label="Збільшити кількість">+</button>' +
      "</div>" +
    "</li>";
  }

  function collectDiscounts(cart) {
    var discounts = {};

    function addDiscount(title, amount) {
      var safeTitle = title || "Знижка";
      discounts[safeTitle] = (discounts[safeTitle] || 0) + (Number(amount) || 0);
    }

    (cart.cart_level_discount_applications || []).forEach(function (application) {
      addDiscount(application.title, application.total_allocated_amount);
    });

    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        var application = allocation.discount_application || {};
        addDiscount(application.title, allocation.amount);
      });
    });

    return discounts;
  }

  function renderSummary(drawer, enriched, moneyFormat) {
    var summary = drawer.querySelector("[data-cart-drawer-summary]");
    if (!summary) return;

    var cart = enriched.cart;
    var productSavings = enriched.items.reduce(function (total, entry) {
      return total + getItemPrices(entry).productSaving;
    }, 0);
    var discountSavings = Number(cart.total_discount) || 0;
    var totalSavings = productSavings + discountSavings;
    var referenceTotal = (Number(cart.total_price) || 0) + totalSavings;
    var shippingThreshold = Number(summary.getAttribute("data-shipping-threshold-cents")) || 0;
    var shippingReached = summary.getAttribute("data-shipping-enabled") === "true" &&
      shippingThreshold > 0 && Number(cart.total_price) >= shippingThreshold;
    var discounts = collectDiscounts(cart);
    var discountTitles = Object.keys(discounts);
    var preview = summary.querySelector("[data-cart-bonuses-preview]");
    var details = summary.querySelector("[data-cart-bonuses-details]");
    var compareTotal = summary.querySelector("[data-cart-summary-compare]");
    var currentTotal = summary.querySelector("[data-cart-summary-total]");
    var previewHtml = "";
    var detailHtml = "";

    var shippingLabel = escapeHtml(summary.getAttribute("data-label-shipping") || "Безкоштовна доставка");
    var saveLabel = escapeHtml(summary.getAttribute("data-label-save") || "Ви економите");
    var emptyLabel = escapeHtml(summary.getAttribute("data-label-empty") || "Бонусів поки немає");
    var activatedLabel = escapeHtml(summary.getAttribute("data-label-activated") || "Активовано");
    var productSavingsLabel = escapeHtml(summary.getAttribute("data-label-product-savings") || "Економія на товарах");
    var bonusesEmptyLabel = escapeHtml(summary.getAttribute("data-label-bonuses-empty") || "Бонуси та знижки з’являться тут");

    if (shippingReached) {
      previewHtml += '<span class="cart-bonuses__shipping">' + shippingLabel + "</span>";
      detailHtml += '<div class="cart-bonuses__line cart-bonuses__line--shipping"><span>' + shippingLabel + "</span><strong>" + activatedLabel + "</strong></div>";
    }
    if (totalSavings > 0) {
      previewHtml += "<span>" + saveLabel + " <strong>" + formatMoney(totalSavings, moneyFormat) + "</strong></span>";
    }
    if (!previewHtml) previewHtml = "<span>" + emptyLabel + "</span>";

    discountTitles.forEach(function (title) {
      if (discounts[title] <= 0) return;
      detailHtml += '<div class="cart-bonuses__line"><span class="cart-bonuses__discount-title">' +
        escapeHtml(title) + '</span><strong>−' + formatMoney(discounts[title], moneyFormat) + "</strong></div>";
    });
    if (productSavings > 0) {
      detailHtml += '<div class="cart-bonuses__line"><span>' + productSavingsLabel + '</span><strong>−' +
        formatMoney(productSavings, moneyFormat) + "</strong></div>";
    }
    if (!detailHtml) {
      detailHtml = '<div class="cart-bonuses__empty">' + bonusesEmptyLabel + "</div>";
    }

    if (preview) preview.innerHTML = previewHtml;
    if (details) details.innerHTML = detailHtml;
    if (currentTotal) currentTotal.innerHTML = formatMoney(cart.total_price, moneyFormat);
    if (compareTotal) {
      compareTotal.hidden = totalSavings <= 0;
      compareTotal.innerHTML = totalSavings > 0 ? formatMoney(referenceTotal, moneyFormat) : "";
    }
  }

  function updateVisibility(drawer, itemCount) {
    var hasItems = itemCount > 0;
    var empty = drawer.querySelector(".no-items");
    if (empty) empty.style.display = hasItems ? "none" : "block";
    drawer.querySelectorAll(".has-items").forEach(function (element) {
      element.style.display = hasItems ? "" : "none";
    });
  }

  function renderCart(cart) {
    var drawer = getDrawer();
    if (!drawer || !cart) return Promise.resolve();

    var currentSequence = ++renderSequence;
    var moneyFormat = drawer.getAttribute("data-money-format") || "${{amount}}";

    return enrichCart(cart).then(function (enriched) {
      if (currentSequence !== renderSequence || !document.documentElement.contains(drawer)) return;
      var list = drawer.querySelector("[data-cart-drawer-items]");
      if (list) {
        list.innerHTML = enriched.items.map(function (entry) {
          return renderItem(entry, moneyFormat);
        }).join("");
      }
      renderSummary(drawer, enriched, moneyFormat);
      updateVisibility(drawer, Number(cart.item_count) || 0);
    });
  }

  function updateHeaderCartCount(cart) {
    document.querySelectorAll("#CartCount_ .cart-products-count, #CartCount_sticky .cart-products-count").forEach(function (count) {
      count.textContent = Number(cart.item_count) || 0;
    });
  }

  function changeCartLine(lineKey, quantity, control) {
    if (!lineKey || quantity < 0) return;
    var item = control.closest("[data-cart-line-key]");
    if (item) item.classList.add("is-updating");

    fetch(getShopRoot() + "cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error("Could not update cart");
      return response.json();
    }).then(function (cart) {
      updateHeaderCartCount(cart);
      window.dispatchEvent(new CustomEvent("theme:cart-updated", { detail: cart }));
    }).catch(function () {
      if (item) item.classList.remove("is-updating");
    });
  }

  document.addEventListener("click", function (event) {
    var control = event.target.closest("[data-cart-remove], [data-cart-quantity-change]");
    if (!control || !control.closest("[data-cart-drawer]")) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var item = control.closest("[data-cart-line-key]");
    if (!item || item.classList.contains("is-updating")) return;
    var lineKey = item.getAttribute("data-cart-line-key");
    var current = Number((item.querySelector("[data-cart-quantity]") || {}).textContent) || 0;
    var quantity = control.hasAttribute("data-cart-remove")
      ? 0
      : Math.max(current + Number(control.getAttribute("data-cart-quantity-change")), 0);
    changeCartLine(lineKey, quantity, control);
  }, true);

  document.addEventListener("click", function (event) {
    var toggle = event.target.closest("[data-cart-bonuses-toggle]");
    if (!toggle) return;
    var details = toggle.closest("[data-cart-bonuses]").querySelector("[data-cart-bonuses-details]");
    var expanded = toggle.getAttribute("aria-expanded") === "true";
    toggle.setAttribute("aria-expanded", String(!expanded));
    if (details) details.hidden = expanded;
  });

  window.addEventListener("theme:cart-updated", function (event) {
    renderCart(event.detail);
  });

  function initialize() {
    fetchCart().then(renderCart).catch(function () {});
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize);
  } else {
    initialize();
  }
})();
